// extracted by mini-css-extract-plugin
module.exports = {"container":"Index_container__3TIif"};